import { render, staticRenderFns } from "./ReadingGroupAggregationForm.vue?vue&type=template&id=974e489a&scoped=true"
import script from "./ReadingGroupAggregationForm.vue?vue&type=script&lang=ts"
export * from "./ReadingGroupAggregationForm.vue?vue&type=script&lang=ts"
import style0 from "./ReadingGroupAggregationForm.vue?vue&type=style&index=0&id=974e489a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974e489a",
  null
  
)

export default component.exports